const day = 1000 * 60 * 60 * 24
const daysPerMonthMean = 30
const months = (monthCount: number) => day * daysPerMonthMean * monthCount

export const EXPIRATION_TIME = months(6)
export const date = (time = 0) => new Date(Date.now() + time).toISOString().slice(0, 10)
